module.exports = __webpack_public_path__ + "static/media/sp2.f8149d76.jpg";